<script setup>
import { computed } from 'vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';

const props = defineProps({
    status: String,
});

const form = useForm();

const submit = () => {
    form.post(route('verification.send'));
};

const verificationLinkSent = computed(() => props.status === 'verification-link-sent');
</script>

<template>
    <Head title="E-mail verificatie" />

    <JetAuthenticationCard>
        <template #logo>
            <JetAuthenticationCardLogo />
        </template>

        <div class="mb-4 text-sm text-gray-600">
            Kan je, voordat je verder gaat, jouw emailadres verifiëren door op de link te klikken die we je zojuist hebben
            gemaild? Als je de e-mail niet hebt ontvangen, sturen wij je graag een nieuwe.
        </div>

        <div v-if="verificationLinkSent" class="mb-4 font-medium text-sm text-green-600">
            Er is een nieuwe verificatielink verzonden naar het e-mailadres dat je in jouw profielinstellingen hebt
            opgegeven.
        </div>

        <form @submit.prevent="submit">
            <div class="mt-4 flex items-center justify-between">
                <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Verificatie e-mail opnieuw verzenden
                </JetButton>

                <div>
                    <Link :href="route('profile.show')" class="underline text-sm text-gray-600 hover:text-gray-900">
                    Profiel bewerken</Link>

                    <Link :href="route('logout')" method="post" as="button"
                        class="underline text-sm text-gray-600 hover:text-gray-900 ml-2">
                    Uitloggen </Link>
                </div>
            </div>
        </form>
    </JetAuthenticationCard>
</template>
